/**
 * Why the last sign-in failed, from the `auth_error` the Google callback lands
 * the browser with. Only "not allowed" differs between the apps, because each
 * admits different people.
 */
export function signInError(notAllowed: string): string | undefined {
  const reasons: Record<string, string> = {
    not_allowed: notAllowed,
    expired: 'That sign-in took too long. Try again.',
    exchange: 'Google did not complete the sign-in. Try again.',
  };
  return reasons[new URLSearchParams(window.location.search).get('auth_error') ?? ''];
}
